import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationService } from '../../../@core/api/notification.service';
import { Notification } from '../../../@core/data/notification';

@Component({
  selector: 'ngx-notification-row',
  templateUrl: './notification-row.component.html',
  styleUrls: ['./notification-row.component.scss']
})
export class NotificationRowComponent implements OnInit {

  @Input() notification: Notification;
  @Output() updateList = new EventEmitter();

  constructor(private notificationService: NotificationService) { }

  ngOnInit() {
  }

  async readNotification(){
    this.notification.read = true;
    await this.notificationService.editNotification(this.notification.id,this.notification)
    this.updateList.emit()
  }

}
